import React, { useState } from "react";
import { motion } from "framer-motion";
import PromoImage from "../images/VIKAS_STUDENT_PIC[1].png";
import QRImage from "../images/qr-code.png";


const BusinessPromo = () => {
  const [showPopup, setShowPopup] = useState(false);
  const togglePopup = () => setShowPopup(!showPopup);

  const benefits = [
    {
      heading: "Instant Digital Presence",
      text: "With Maamaas, you get your own professional business profile, complete with services, pricing, photos, and branding. You don’t need to spend lakhs on creating a website or app because Maamaas acts as your digital storefront. Customers can discover your business in your local area and beyond, instantly connecting you with new opportunities.",
    },
    {
      heading: "All-in-One Business Hub",
      text: "Running multiple apps or maintaining separate registers can be exhausting. Maamaas simplifies everything by combining order management, bookings, deliveries, accounts, and customer communications into one platform. This all-in-one hub gives you complete control over your business while saving time and reducing errors.",
    },
    {
      heading: "Smart Digital Billing & Payments",
      text: "Say goodbye to handwritten bills and manual payment tracking. Maamaas allows you to generate digital invoices, send receipts directly to customers, and track all transactions in real time. Professional billing not only saves time but also builds trust with your customers.",
    },
    {
      heading: "Zero Commission for the First Year",
      text: "Maamaas gives you the freedom to grow without losing money. During your first year, you keep 100% of your earnings with no commission deducted from any order or bill. This allows you to maximize revenue and reinvest in your business.",
    },
    {
      heading: "Subscription-Based Access",
      text: "Instead of paying per-order commissions, you pay a predictable subscription fee that unlocks all the tools Maamaas has to offer. From digital order management to analytics, billing, and customer engagement, everything is included to help your business operate efficiently and professionally.",
    },
    {
      heading: "Nominal Platform Fee on Billing",
      text: "A small, transparent platform fee ensures uninterrupted access to Maamaas’ technology and support while keeping most of your revenue intact. This predictable structure makes financial planning easier and avoids surprises.",
    },
  ];

  return (
    <>
      <style>{`
        .promo-container {
          display: flex;
          justify-content: space-between;
          align-items: center;
          background-color: #2a0947;
          padding: 50px;
          flex-wrap: wrap;
          margin-top: -67px;
        }

        .promo-heading {
          font-size: 50px;
          font-weight: bold;
          text-align: center;
          color: white;
          margin-top: 30px;
          font-family: Lato, sans-serif;
        }

        .highlight {
          color: rgb(255, 225, 36);
        }

        .text-grid {
          display: grid;
          grid-template-columns: repeat(2, 1fr);
          gap: 30px;
          max-width: 55%;
          color: white;
          font-family: Arial, sans-serif;
        }

        .text-box {
        margin-top:30px;
          padding: 16px;
          background-color: white;
          border-radius: 12px;
          box-shadow: 0 4px 8px rgba(0,0,0,0.1);
        }

        .text-heading {
          font-size: 20px;
          font-weight: bold;
          color: #2a0947;
          margin-bottom: 6px;
        }

        .text-subtext {
          font-size: 16px;
          color: #2a0947;
          text-aligh:justify;
        }

        .image-side {
          max-width: 40%;
        }

        .promo-image {
          width: 100%;
          border-radius: 10px;
        }

        .downloadBtn {
          margin-top: 30px;
          background-color: #ffe124;
          color: #2a0947;
          padding: 12px 25px;
          font-size: 18px;
          border: none;
          border-radius: 8px;
          cursor: pointer;
          font-weight: bold;
        }

        .popupOverlay {
          position: fixed;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          background: rgba(0, 0, 0, 0.6);
          display: flex;
          justify-content: center;
          align-items: center;
          z-index: 1000;
        }

        .popupInner {
          background: white;
          padding: 30px;
          border-radius: 10px;
          text-align: center;
          max-width: 400px;
          position: relative;
        }

        .closeBtn {
          position: absolute;
          top: 10px;
          right: 15px;
          background: none;
          border: none;
          font-size: 20px;
          cursor: pointer;
        }

        .scannerImg {
          width: 200px;
          margin-bottom: 15px;
        }

        @media (max-width: 768px) {
          .promo-container {
            flex-direction: column-reverse;
            padding: 30px 20px;
          }

          .text-grid {
            max-width: 100%;
            grid-template-columns: repeat(1, 1fr);
          }

          .image-side {
            max-width: 90%;
            margin-bottom: 20px;
          }

          .promo-heading {
            font-size: 36px;
          }
        }
      `}</style>

      <div style={{ textAlign: "center", backgroundColor: "#2a0947" }}>
        <h1 className="promo-heading">
          Why Join  <span className="highlight">Maamaas ?</span>
        </h1>
      </div>

      <div className="promo-container">
        {/* Left Side Image */}
        <motion.div
          className="image-side"
          initial={{ opacity: 0, x: 50 }}
          animate={{ opacity: 1, x: 0 }}
          transition={{ duration: 1 }}
        >
          <img src={PromoImage} alt="Promotional" className="promo-image" />
        </motion.div>

        {/* Right Side Text */}
        <motion.div
          className="text-grid"
          initial={{ opacity: 0, x: -50 }}
          animate={{ opacity: 1, x: 0 }}
          transition={{ duration: 1 }}
        >
          {benefits.map((item, index) => (
            <div className="text-box" key={index}>
              <div className="text-heading">{item.heading}</div>
              <div className="text-subtext">{item.text}</div>
            </div>
          ))}

          <div style={{ gridColumn: "1 / -1", textAlign: "center" }}>
            <button className="downloadBtn" onClick={togglePopup}>
              Download App
            </button>
          </div>

          {showPopup && (
            <div className="popupOverlay">
              <div className="popupInner">
                <button className="closeBtn" onClick={togglePopup}>×</button>
                <img src={QRImage} alt="QR Code Scanner" className="scannerImg" />
                <p style={{ color: "black" }}>Scan the QR code to download the Maamaas App!</p>
              </div>
            </div>
          )}
        </motion.div>
      </div>
    </>
  );
};

export default BusinessPromo;
